import * as Yup from 'yup';

export const teacherValidationSchema = Yup.object().shape({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  email: Yup.string().email('Invalid email format').required('Email is required'),
  teacherId: Yup.string().required('Teacher ID is required'),
  password: Yup.string().min(6, 'Password should be at least 6 characters').required('Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords must match')
    .required('Please confirm your password'),
});

export const badgeValidationSchema = Yup.object().shape({
  name: Yup.string().required('Badge name is required'),
  description: Yup.string().required('Description is required'),
  points: Yup.number()
    .required('Points are required')
    .min(0, 'Points must be greater than or equal to 0')
    .integer('Points must be a whole number'),
});
